export const ProgressIndicator = ({ percent }: { percent: number }) => {
  // Display a minimum of 10% progress because less than that squeezes the progress bar circle
  // into a oval, which looks bad.
  const displayPercent = Math.max(10, percent);
  return (
    <div
      className="
      h-4 w-full
      rounded-[12px]
      bg-slate-300
    "
    >
      <div
        className="
      h-full 
      rounded-[8px] 
      border 
      border-accent-emphasis bg-slate-200
    "
        style={{ width: `${displayPercent}%` }}
      />
    </div>
  );
};
